<template>
    <v-card
        :to="!this.disabled && !this.warningTask? { query: { dateBasedTaskId: value.id } } : null"
        :outlined="this.warningTask"
        :class="classes"
    >
        <v-list style="background:inherit;">
            <div
                v-if="value.defectCount"
                class="caption"
                align="right"
            >{{value.defectCount}} Scheduled Defect/s
            </div>
            <v-row>
                <div style="min-width:40px" class="ml-4">
                    <v-icon>event</v-icon>
                </div>
                <div v-if="!value.hasFailedMetrics">
                    <v-chip :small="true">{{value.unitNumber}} ({{value.unitDepartment}})</v-chip>
                </div>
                <div v-if="!!value.hasFailedMetrics">
                    <v-chip :small="true" class="red white--text">{{value.unitNumber}} ({{value.unitDepartment}})</v-chip>
                </div>
                <v-menu>
                    <template v-slot:activator="{ on }">
                        <v-btn height="24" icon text x-small v-on="on" @click="handleClick">
                            <v-icon>info</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <v-list-item-title>{{value.unitNumber}} ({{value.unitDepartment}})</v-list-item-title>
                                <v-list-item-subtitle>{{value.unitName}}</v-list-item-subtitle>
                                <v-list-item-subtitle>{{value.unitGarageLocation}}</v-list-item-subtitle>
                                <v-list-item-subtitle>{{value.unitInstallationAddress}}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-spacer/>
                            <v-chip v-if="!!value.hasFailedMetrics" class="red white--text">Failed Metrics</v-chip>
                            <v-chip v-if="!!value.isLowUse" class="purple lighten-2 white--text">Low Use Unit</v-chip>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-row>
            <v-list-item>
                <v-chip v-if="warningTask">
                    <v-icon>assignment_late</v-icon>
                    {{value.description}} due {{moment(value.dueDate).format("DD MMM YYYY")}}
                </v-chip>
                <v-chip v-else>{{value.description}}</v-chip>
            </v-list-item>
        </v-list>
    </v-card>
</template>
<script>
  import UnitLabel from '@/components/Units/UnitLabel.vue';
  import {GarageLocationStore} from '@/stores/GarageLocationStore';

  export default {
    props: {
      value: {required: true}
    },
    components: {UnitLabel},
    methods: {
      handleClick(e) {
        e.stopPropagation();
        e.preventDefault();
      }
    },
    computed: {
      completed() {
        return !!this.value.completedDate;
      },
      warningTask() {
        return this.value.warningDate === this.moment(this.date).format('YYYY-MM-DD');
      },
      disabled() {
        const g = GarageLocationStore.data.userGarage;
        const garages = GarageLocationStore.data.userGarages;
        return !this.completed && !this.userIsDataEntryInGarage(g, garages)
          && !this.userIsWorkshopManagerInGarage(g, garages)
          && !this.userIsFleetManager;
      },
      date() {
        return this.$route.params && this.$route.params.date;
      },
      classes() {
        return {
          'ma-1': true,
          disabled: this.disabled,
          completed: this.completed,
          sweptForward: !this.completed && this.value.sweptForwardByScheduler
        };
      }
    }
  };
</script>
